import { Tooltip, Typography } from "@mui/material";

type Props = {
  children: string;
  variant?: "subtitle2" | "caption" | "body2";
  sx?: any;
};

export default function OverflowTooltip({
  children,
  variant = "body2",
  sx,
}: Props) {
  return (
    <Tooltip title={children} arrow placement="top">
      <Typography
        variant={variant}
        noWrap
        sx={{
          display: "block",
          maxWidth: 120,
          textOverflow: "ellipsis",
          overflow: "hidden",
          ...sx,
        }}
      >
        {children}
      </Typography>
    </Tooltip>
  );
}

